
import TranslationsService from './services/Translations';
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import './plugins'
// @ts-ignore
import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.use(VueFriendlyIframe);

// set config
Vue.config.productionTip = false

// init vue
new Vue({
  i18n: TranslationsService.i18n,
  router,
  vuetify,
  render: h => h(App)
})
  .$mount('#app')

